import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "tab", "content" ]

  connect() {
    // Determine active tab on start, default to predictions
    const activeTab = this.tabTargets.find(tab => tab.classList.contains("active-tab-indicator"))
    const activeId = activeTab ? activeTab.dataset.tabId : "predictions"
    this.showTab(activeId)
  }

  change(event) {
    event.preventDefault()
    const selectedId = event.currentTarget.dataset.tabId
    this.showTab(selectedId)
  }

  showTab(selectedId) {
    // Style tabs
    this.tabTargets.forEach(tab => {
      const isSelected = tab.dataset.tabId === selectedId
      if (isSelected) {
        // Active Tab styles
        tab.classList.add("border-indigo-600", "text-indigo-600", "dark:text-indigo-400", "active-tab-indicator")
        tab.classList.remove("border-transparent", "text-slate-500", "hover:text-slate-700")
      } else {
        // Inactive Tab styles
        tab.classList.remove("border-indigo-600", "text-indigo-600", "dark:text-indigo-400", "active-tab-indicator")
        tab.classList.add("border-transparent", "text-slate-500", "hover:text-slate-700")
      }
    })

    // Show/Hide content
    this.contentTargets.forEach(content => {
      if (content.id === selectedId) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
